import { useCallback } from 'react';
import ProductDB from '../../../../../database/wrappers/product';
import useBasePriceImport from './useBasePriceImport';

const chunkArray = (list, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < list.length; i += chunkSize) {
    chunks.push(list.slice(i, i + chunkSize));
  }
  return chunks;
};

const useProductPriceImport = ({ establishmentId, products, onShowAlert }) => {
  const handleSaveRows = useCallback(async (rowsToUpdate) => {
    const productDB = new ProductDB(establishmentId);
    const chunks = chunkArray(rowsToUpdate, 200);

    for (const chunk of chunks) {
      await Promise.all(chunk.map((item) => productDB.update(item.id, { price: item.newPrice })));
    }
  }, [establishmentId]);

  return useBasePriceImport({
    canImport: !!establishmentId,
    products,
    onShowAlert,
    onSaveRows: handleSaveRows,
  });
};

export default useProductPriceImport;